import Vue from 'vue'

import SignIn from './SignIn'

Vue.component('a-sign-in', SignIn)

export {
  SignIn
}
